import { render, staticRenderFns } from "./BannerComponent.vue?vue&type=template&id=06d0e6e8&scoped=true&v-on-clickaway=cancel&"
import script from "./BannerComponent.vue?vue&type=script&lang=ts&"
export * from "./BannerComponent.vue?vue&type=script&lang=ts&"
import style0 from "./BannerComponent.vue?vue&type=style&index=0&id=06d0e6e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d0e6e8",
  null
  
)

export default component.exports